import { render, staticRenderFns } from "./BarChartECharts2.vue?vue&type=template&id=5cb6685d&"
import script from "./BarChartECharts2.vue?vue&type=script&lang=js&"
export * from "./BarChartECharts2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports